import { makeStyles } from "@material-ui/core";

export const RoofSystemStyle = makeStyles((theme) => ({
    root: {
        backgroundColor: "#F4F5F5",
        marginBottom: "2.5rem",
        padding: "40px 15px",
        [theme.breakpoints.up("sm")]: {
            padding: "40px",
        },
        [theme.breakpoints.up("lg")]: {
            padding: "20px 60px",
        },
    },
}));
